module.exports = __webpack_public_path__ + "img/random1.8a83b3b0.png";